import axios from "@/lib/axios";

const getCustomer = (custCode: string | undefined) => {
  return axios.get(`/facility/facility_agreements/customers/${custCode}`);
}

export default getCustomer;